import {
  Alert,
  Divider,
  Icon,
  Text,
  useBreakpoint
} from '@cencosud-cencommerce/paris-uikit';
import classNames from 'classnames';

import { useCart } from '@/Application/Selectors/cart/useCart';

import NoProductsOnStock from './NoProductsOnStock';
// TODO: Try to get shop from the products
import ProductList from './ProductList';

const OutOfStockProducts = () => {
  const { data: cart } = useCart();
  const { isMobile } = useBreakpoint();
  const allProductsAreOutOfStock = cart?.lineItems.length === 0;

  if (!cart || !cart.outOfStockItems || !cart.outOfStockItems.length) {
    return null;
  }

  return (
    <div
      className={classNames(
        'co-w-full co-bg-white co-flex co-flex-col co-items-center co-justify-center',
        'co-border co-rounded-lg co-border-neutral-300 co-relative'
      )}
    >
      <div
        className="co-flex co-flex-col co-w-full co-h-full"
        data-testid="co-delivery-card"
      >
        <div
          className={classNames(
            'co-flex co-justify-between co-w-full',
            'tablet:co-p-4 co-border-b co-border-b-neutral-300',
            'co-flex-col tablet:co-flex-row'
          )}
        >
          <div
            className={classNames(
              'co-flex tablet:co-gap-2 co-items-center',
              'co-p-3 tablet:co-p-0 co-justify-between'
            )}
          >
            <div className="co-flex co-gap-2 co-items-center">
              <Icon name="il-product" className="co-w-8 co-h-8" />
              <Text variant="subtitle2" weight={600}>
                Productos agotados
              </Text>
            </div>
          </div>
        </div>
      </div>
      <div className="co-py-2 co-px-3 co-w-full co-flex co-flex-col co-gap-2.5">
        {!allProductsAreOutOfStock && (
          <Alert
            body=" ¡Lo sentimos! Guárdalos para después o prueba con otra comuna. Si continúas con el pago serán eliminados de tu carro."
            status="warning"
          />
        )}
        <ProductList />
      </div>
      {allProductsAreOutOfStock && isMobile && (
        <>
          <Divider />
          <div className="co-w-full co-py-4 co-px-[12px]">
            <NoProductsOnStock />
          </div>
        </>
      )}
    </div>
  );
};

export default OutOfStockProducts;
